const DocumentOcult = [
    {id:"6", nombre: "Ficha de matrícula"}, 
    {id:"122",nombre:"Ficha de postulación"}
]

 

export default DocumentOcult;